const MISSIONKIND_MAP: { [id: number] : Array<string> } = {
    1: ["New", "NEW", "新しい問題へ進もう！"],
    2: ["Revenge", "リベンジ", "目指せ全問正解！"],
    3: ["Repeat", "くり返し", "定着させよう！"],
    4: ["Overcome","苦手克服", "弱点をなくそう！"]
}

const MISSIONKIND_SORT = {
    NEW: 1,
    REVENGE: 2,
    REPEAT: 3,
    OVERCOME: 4
}

export {MISSIONKIND_MAP, MISSIONKIND_SORT}